import { useMutateEntry } from '@utils/component-framework';

const useMarkCardAsSeenMutation = entryKey => {
  const updateComponentEntry = useMutateEntry(entryKey);
  return cardIndex => {
    updateComponentEntry(entry => {
      entry.data.cards.length = Math.max(entry.data.cards.length, cardIndex + 1);

      // Ensure that we fill missing indicies
      for (let i = 0; i < entry.data.cards.length; i++) {
        if (!entry.data.cards[i]) {
          entry.data.cards[i] = {
            flipped: false
          };
        }
      }
      entry.data.cards[cardIndex] = {
        flipped: true
      };
      return entry;
    });
  };
};

export { useMarkCardAsSeenMutation };
//# sourceMappingURL=mutation.mark-card-as-seen.js.map
